// Import the RTK Query methods from the React-specific entry point
import { createApi } from '@reduxjs/toolkit/query/react'
import { getAccessToken } from '@/auth/getAccessToken'
import { createStaffBaseQuery } from './staffBaseQuery'

// Build-time replaced by Bun's define plugin; in dev (HMR) this is undefined
declare const __API_BASE_URL__: string | undefined;
const API_BASE_URL = typeof __API_BASE_URL__ !== "undefined" ? __API_BASE_URL__ : "";

// Define our single API slice object
export const api = createApi({
  // The cache reducer expects to be added at `state.api` (already default - this is optional)
  reducerPath: 'api',
  // All of our requests will have URLs starting with API_BASE_URL
  baseQuery: createStaffBaseQuery({ baseUrl: API_BASE_URL, getAccessToken }),
  // The "endpoints" represent operations and requests for this server
  endpoints: builder => ({})
})